export default __webpack_public_path__ + "static/media/Avtosepka1.2.2bd6385b.png";